import { render } from "./CreatePost.vue?vue&type=template&id=2afe39e0&scoped=true"
import script from "./CreatePost.vue?vue&type=script&lang=js"
export * from "./CreatePost.vue?vue&type=script&lang=js"

import "./create-post.scss?vue&type=style&index=0&id=2afe39e0&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afe39e0"]])

export default __exports__